import { useState } from 'react'

import { Chat, ChatParticipantRole } from '@tribeplatform/gql-client/types'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { T } from '../../i18n/index.js'
import { useChatActions } from '../hooks/useChatActions.js'

import { ActionItem } from './ActionItem.js'
import { UpdateGroupChatModal } from './UpdateGroupChatModal.js'

interface Props {
  chat: Chat
}

export const GroupChatActions = ({ chat }: Props) => {
  const [isOpenUpdateModal, setIsOpenUpdateModal] = useState(false)
  const { archiveChat, leaveGroupChat, unarchiveChat } = useChatActions({
    chatId: chat._id,
  })
  const isStaff =
    chat.currentParticipant?.role === ChatParticipantRole.Admin ||
    chat.currentParticipant?.role === ChatParticipantRole.Owner
  const isArchived = chat.currentParticipant?.archivedAt !== null

  return (
    <div className="flex flex-col w-full">
      <div className="text-sm text-content-muted p-3">
        <T
          id="Messaging.GroupChatActions.Title"
          defaultMessage="Group actions"
        />
      </div>
      <div className="flex flex-col gap-1 px-1">
        {isStaff && (
          <ActionItem
            label={
              <T
                id="Messaging.GroupChatActions.Edit"
                defaultMessage="Edit Group"
              />
            }
            onClick={() => setIsOpenUpdateModal(true)}
            icon={<SvgIcon name="edit-2" size="lg" />}
          />
        )}
        {!isArchived ? (
          <ActionItem
            label={
              <T
                id="Messaging.GroupChatActions.Archive"
                defaultMessage="Archive Group"
              />
            }
            onClick={archiveChat}
            icon={<SvgIcon name="archive" size="lg" />}
          />
        ) : (
          <ActionItem
            label={
              <T
                id="Messaging.GroupChatActions.Unarchive"
                defaultMessage="Unarchive Group"
              />
            }
            onClick={unarchiveChat}
            icon={<SvgIcon name="undo" size="lg" />}
          />
        )}
        <ActionItem
          label={
            <T
              id="Messaging.GroupChatActions.Leave"
              defaultMessage="Leave Group"
            />
          }
          onClick={leaveGroupChat}
          icon={<SvgIcon name="logout" size="xl" />}
          className="text-interactive-destructive"
        />
        {/* <ActionItem
          label={
            <T id="Messaging.ChatActions.Delete" defaultMessage="Delete Chat" />
          }
          onClick={() => {}}
          icon={<SvgIcon name="trash" size="lg" />}
          className="text-interactive-destructive"
        /> */}
      </div>
      <UpdateGroupChatModal
        chat={chat}
        open={isOpenUpdateModal}
        onClose={() => setIsOpenUpdateModal(false)}
      />
    </div>
  )
}
